import React from "react";

const FeatureSection = () => {
  return (
    <section className="feature-section section-padding">
      <div className="container">
        <div className="row">
          <div
            className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
            data-wow-delay=".2s"
          >
            <div className="feature-card-items">
              <div className="icon">
                <img src="/img/icon/01.svg" alt="img" />
              </div>
              <div className="content">
                <h3>A Lot of Discount</h3>
              </div>
            </div>
          </div>

          <div
            className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
            data-wow-delay=".4s"
          >
            <div className="feature-card-items">
              <div className="icon bg-color">
                <img src="/img/icon/02.svg" alt="img" />
              </div>
              <div className="content">
                <h3>Best Guide</h3>
              </div>
            </div>
          </div>

          <div
            className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
            data-wow-delay=".6s"
          >
            <div className="feature-card-items">
              <div className="icon">
                <img src="/img/icon/03.svg" alt="img" />
              </div>
              <div className="content">
                <h3>24/7 Support</h3>
              </div>
            </div>
          </div>

          <div
            className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp"
            data-wow-delay=".8s"
          >
            <div className="feature-card-items">
              <div className="icon">
                <img src="/img/icon/04.svg" alt="img" />
              </div>
              <div className="content">
                <h3>Travel Management</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
